// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-form[data-v-423a54fc] {\n  max-height: 600px;\n  overflow-y: scroll;\n}\n", ""]);
// Exports
module.exports = exports;
